import styled from 'styled-components';

import { pxToRem } from '@utils/converters';

type Size = 'sm' | 'md' | 'lg';

export type SquareImageProps = {
  src: string;
  size?: Size | number;
  borderRadius?: number;
  alt?: string;
};

const sizeMap: Record<Size, number> = {
  sm: 24,
  md: 32,
  lg: 48,
};

export const SquareImage = styled.img<SquareImageProps>(({ size = 'sm', borderRadius }) => {
  const calculatedSize = pxToRem(typeof size === 'number' ? size : sizeMap[size]);

  return {
    width: calculatedSize,
    height: calculatedSize,
    borderRadius: borderRadius ? pxToRem(borderRadius) : '0',
  };
});
